var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, CircularProgress } from '../index';
import '@mui/material/styles/createPalette';
const ExtensivButton = (_a) => {
    var { children, disabled = false, color = 'primary', endIcon = null, href = '', isLoading = false } = _a, otherProps = __rest(_a, ["children", "disabled", "color", "endIcon", "href", "isLoading"]);
    const [hovered, setHovered] = useState(false);
    if (href) {
        otherProps = Object.assign(Object.assign({}, otherProps), {
            component: RouterLink,
            to: href
        });
    }
    const toggleHover = () => setHovered(!hovered);
    return (_jsx(Button, Object.assign({ onMouseEnter: toggleHover, onMouseLeave: toggleHover, disabled: disabled || isLoading, color: color, endIcon: isLoading ? _jsx(CircularProgress, { color: color, size: 15 }) : endIcon }, otherProps, { disableElevation: false }, { children: children })));
};
export default ExtensivButton;
//# sourceMappingURL=index.js.map